import "./App.css";
import "./responsive.css";

import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Navbar from "./components/layouts/Navbar";
import Footer from "./components/layouts/Footer";
import JoinConfirmationModal from "./components/sections/JoinConfirmationModal";
import SwapPage from "./components/sections/SwapPage";
/* ===========================
   PAGES
=========================== */

import Home from "./components/sections/Home";
import Dashboard from "./components/sections/Dashboard";
import Leaderboard from "./components/sections/Leaderboard";
import League from "./components/sections/League";
import Rewards from "./components/sections/Rewards";
import Profile from "./components/sections/Profile";
import History from "./components/sections/History";
import Rules from "./components/sections/Rules";
import Admin from "./components/sections/Admin";

/* ===========================
   REOWN APPKIT
=========================== */

import {
  createAppKit,
} from "@reown/appkit/react";

import {
  EthersAdapter,
} from "@reown/appkit-adapter-ethers";

import {
  bsc,
} from "@reown/appkit/networks";

import {
  BASE_URL,
} from "./constant";

/* ===========================
   BSC MAINNET RPC
=========================== */

const BSC_MAINNET_RPC =
  "https://bsc-dataseed.bnbchain.org";

/* ===========================
   REOWN PROJECT ID
=========================== */

const projectId =
  "7b037fb00655ef362c37f963e74a16b8";

/* ===========================
   CUSTOM BSC MAINNET
=========================== */

const customBscMainnet = {
  ...bsc,

  rpcUrls: {
    ...bsc.rpcUrls,

    default: {
      http: [
        BSC_MAINNET_RPC,
      ],
    },

    public: {
      http: [
        BSC_MAINNET_RPC,
      ],
    },
  },
};

/* ===========================
   APPKIT
=========================== */

createAppKit({
  /* =========================
     ETHERS ADAPTER
  ========================= */

  adapters: [
    new EthersAdapter(),
  ],

  /* =========================
     BSC MAINNET ONLY
  ========================= */

  networks: [
    customBscMainnet,
  ],

  /* =========================
     DEFAULT NETWORK
  ========================= */

  defaultNetwork:
    customBscMainnet,

  /* =========================
     PROJECT ID
  ========================= */

  projectId,

  /* =========================
     METADATA
  ========================= */

  metadata: {
    name:
      "Kind Bonus Rush",

    description:
      "Kind Bonus Rush | Buy KIND • Earn Rewards",

    url:
      BASE_URL,

    icons: [
      `${BASE_URL}/kindlogo.png`,
    ],
  },

  /* =========================
     WALLET / NETWORK
  ========================= */

  enableNetworkSwitch:
    true,

  /* =========================
     INJECTED WALLETS
  ========================= */

  enableEIP6963:
    true,

  /* =========================
     FEATURES
  ========================= */

  features: {
    analytics:
      true,
  },

  /* =========================
     THEME
  ========================= */

  themeMode:
    "dark",

  themeVariables: {
    "--w3m-accent":
      "#ffcc66",

    "--w3m-color-mix":
      "#191a1b",

    "--w3m-color-mix-strength":
      20,

    "--w3m-border-radius-master":
      "4px",
  },
});

/* ===========================
   LAYOUT
=========================== */

function Layout({
  children,
}) {
  return (
    <div className="min-h-screen bg-[#050b08] text-white">

      <Navbar />

      <main>
        {children}
      </main>

      <Footer />

    </div>
  );
}

/* ===========================
   APP
=========================== */

function App() {
  return (
    <>
      {/* GLOBAL CONFIRMATION - ALL PAGES */}
      <JoinConfirmationModal />

      <Routes>

        <Route
          path="/"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />

        <Route
          path="/dashboard"
          element={
            <Layout>
              <Dashboard />
            </Layout>
          }
        />

        <Route
          path="/leaderboard"
          element={
            <Layout>
              <Leaderboard />
            </Layout>
          }
        />

        <Route
          path="/league"
          element={
            <Layout>
              <League />
            </Layout>
          }
        />

        <Route
          path="/rewards"
          element={
            <Layout>
              <Rewards />
            </Layout>
          }
        />
            <Route
          path="/swap"
          element={
            <Layout>
              <SwapPage />
            </Layout>
          }
        />

        <Route
          path="/profile"
          element={
            <Layout>
              <Profile />
            </Layout>
          }
        />

        <Route
          path="/history"
          element={
            <Layout>
              <History />
            </Layout>
          }
        />

        <Route
          path="/rules"
          element={
            <Layout>
              <Rules />
            </Layout>
          }
        />

        <Route
          path="/admin"
          element={
            <Layout>
              <Admin />
            </Layout>
          }
        />

        <Route
          path="*"
          element={
            <Navigate
              to="/"
              replace
            />
          }
        />

      </Routes>
    </>
  );
}

export default App;